module.exports = __webpack_public_path__ + "img/1520062541.04b7e9cb.jpg";